import { Instagram, Linkedin, Mail, Phone, Youtube } from "lucide-react";
import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer id="contact" className="bg-[#111010] py-10 font-['Inter'] text-[#EBFFEE]">
      <div className="container mx-auto px-4 space-y-6">
        <div className="border-t border-[#504A4A]/70 pt-6">
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
            <div className="flex items-center justify-center lg:justify-start gap-4 text-[#A9A3A3] text-sm">
              <a
                href="https://www.instagram.com/rollopsgymos"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#EBFFEE] transition-colors"
              >
                <Instagram className="w-4 h-4" />
                Instagram
              </a>
              <a
                href="https://www.linkedin.com/company/rollops"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#EBFFEE] transition-colors"
              >
                <Linkedin className="w-4 h-4" />
                LinkedIn
              </a>
              <a
                href="https://www.youtube.com/@rollops"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#EBFFEE] transition-colors"
              >
                <Youtube className="w-4 h-4" />
                YouTube
              </a>
            </div>

            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-[#A9A3A3] text-sm">
              <a href="/athlete-sponsorship" className="hover:text-[#EBFFEE] transition-colors">
                Athlete Sponsorship
              </a>
              <a href="/affiliate-program" className="hover:text-[#EBFFEE] transition-colors">
                Affiliate Partner
              </a>
              <a href="/sponsorship-brand-ambassador" className="hover:text-[#EBFFEE] transition-colors">
                Brand Ambassador
              </a>
              <a href="/careers" className="hover:text-[#EBFFEE] transition-colors">
                Careers
              </a>
              <a href="/privacy" className="hover:text-[#EBFFEE] transition-colors">
                Privacy Policy
              </a>
              <a href="/terms" className="hover:text-[#EBFFEE] transition-colors">
                Terms of Service
              </a>
              <a href="/delete-account" className="hover:text-[#EBFFEE] transition-colors">
                Delete Account
              </a>
            </div>

            <div className="flex items-center justify-center lg:justify-end gap-2 text-[#A9A3A3]">
              <img src="/rollops-logo.png" alt="RollOps Podcast" width={28} height={28} className="w-7 h-7" />
              <span className="text-sm text-[#EBFFEE]">RollOps Podcast</span>
            </div>
          </div>

          <div className="mt-6 text-center text-[#A9A3A3] text-sm space-y-2">
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-center gap-2 sm:gap-4">
              <div className="flex items-center justify-center space-x-2">
                <Mail className="w-4 h-4" />
                <span>support@rollops.pro</span>
              </div>
              <div className="flex items-center justify-center space-x-2">
                <Phone className="w-4 h-4" />
                <span>(757) 655-6779</span>
              </div>
            </div>
            <div>1908 Thomes Ave STE 12408 Cheyenne, WY 82001</div>
          </div>

          <div className="mt-4 text-center text-[#706A6A] text-sm">
            <p>&copy; {new Date().getFullYear()} RollOps. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};